document.addEventListener('DOMContentLoaded', function () {
  if (window.__dhThemeInit) return;
  window.__dhThemeInit = true;

  // Mobile menu
  var burger = document.querySelector('.dh-mobile-bar__burger');
  var mobileMenu = document.getElementById('dh-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(isOpen));
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Accordion (categories + footer)
  document.querySelectorAll('.dh-category__toggle, .dh-footer-accordion__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // Carousels
  document.querySelectorAll('.dh-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.dh-carousel__track');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.dh-carousel__slide'));
    var prev = carousel.querySelector('.dh-carousel__arrow--prev');
    var next = carousel.querySelector('.dh-carousel__arrow--next');
    var dotsWrap = carousel.parentElement.querySelector('.dh-carousel__dots');
    if (!track || !slides.length) return;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Vai a immagine ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsWrap && dotsWrap.appendChild(dot);
    });
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

    function setActiveDot() {
      var scrollLeft = track.scrollLeft;
      var index = 0;
      var closest = Infinity;
      slides.forEach(function (slide, i) {
        var diff = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
        if (diff < closest) { closest = diff; index = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(setActiveDot);
    }, { passive: true });

    function scrollByAmount(dir) {
      var amount = slides[0].getBoundingClientRect().width + 20;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    prev && prev.addEventListener('click', function () { scrollByAmount(-1); });
    next && next.addEventListener('click', function () { scrollByAmount(1); });
  });
});
